export const COUNTER_UNSUBSCRIBE = -1
export const DEFAULT_MAX_NEIGHBOR_COUNT = 4
